import TagManager from 'react-gtm-module'

export function sendChangeFlightGTM(priceChange: number, priceChangePerPerson: number): void {
  TagManager.dataLayer({
    dataLayer: {
      event: 'change_flight',
      total_price_change: priceChange,
      total_price_change_per_person: priceChangePerPerson,
    },
  })
}
